var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUserIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.322,
    height: 25.96,
    viewBox: "0 0 20.322 25.96",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Component_1478",
    "data-name": "Component 1478",
    transform: "translate(1 1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Component_117_1",
    "data-name": "Component 117 \\u2013 1",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4389",
    "data-name": "Path 4389",
    d: "M92.321,10.579a5.118,5.118,0,0,0,3.74-1.55,5.118,5.118,0,0,0,1.549-3.74,5.119,5.119,0,0,0-1.55-3.74,5.288,5.288,0,0,0-7.48,0,5.118,5.118,0,0,0-1.55,3.74,5.118,5.118,0,0,0,1.55,3.74A5.119,5.119,0,0,0,92.321,10.579Zm0,0",
    transform: "translate(-83.298 0)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4390",
    "data-name": "Path 4390",
    d: "M18.278,253.6a13.066,13.066,0,0,0-.178-1.388,10.93,10.93,0,0,0-.341-1.4,6.889,6.889,0,0,0-.574-1.3,4.912,4.912,0,0,0-.865-1.127,3.813,3.813,0,0,0-1.242-.781,4.293,4.293,0,0,0-1.586-.287,1.61,1.61,0,0,0-.86.365c-.258.168-.559.362-.9.577a5.132,5.132,0,0,1-1.159.511,4.5,4.5,0,0,1-2.835,0,5.125,5.125,0,0,1-1.158-.51c-.333-.213-.635-.407-.9-.578a1.608,1.608,0,0,0-.859-.365,4.288,4.288,0,0,0-1.586.287A3.811,3.811,0,0,0,2,248.384a4.909,4.909,0,0,0-.865,1.127,6.9,6.9,0,0,0-.574,1.3,10.959,10.959,0,0,0-.341,1.4A13.018,13.018,0,0,0,.044,253.6c-.029.42-.044.856-.044,1.3a3.647,3.647,0,0,0,1.083,2.759,3.9,3.9,0,0,0,2.791,1.018H14.448a3.9,3.9,0,0,0,2.791-1.018,3.645,3.645,0,0,0,1.083-2.759C18.322,254.45,18.307,254.013,18.278,253.6Zm0,0",
    transform: "translate(0 -234.709)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 2
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserIcon);
export default __webpack_public_path__ + "static/media/UserIcon.1469a98abaddc272c101d8fe439752cf.svg";
export { ForwardRef as ReactComponent };